import { ComboboxItem } from '@oncolens/oncolens-ui/lib/components/FormControls/Combobox/Combobox';
import DefaultButton from '@oncolens/oncolens-ui/lib/components/FormControls/DefaultButton';
import React, { useState } from 'react';
import { BsPlusCircle } from 'react-icons/bs';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useNavigate } from 'react-router';
import GuidelinesTable from './GuidelinesTable';
import TableOrgFilter from './TableOrgFilter';
import TableSearch from './TableSearch';

export default function GuidelinesList() {
  const [queryValue, setQueryValue] = useState('');
  const [selectedOrgs, setSelectedOrgs] = useState<ComboboxItem[]>([]);
  const navigate = useNavigate();

  return (
    <div>
      <div className="flex items-center my-3 space-x-2.5">
        <TableOrgFilter setSelectedOrgs={setSelectedOrgs} />
        <TableSearch setQuery={setQueryValue} testSelector="guidelines-list-search" />

        <DefaultButton
          onClick={() => navigate('/behavior-config/guidelines/guideline/add')}
          testSelector="add-guideline">
          <BsPlusCircle className="mr-2" /> Create Guideline
        </DefaultButton>
      </div>
      <GuidelinesTable searchQuery={queryValue} orgFilter={selectedOrgs} />
    </div>
  );
}
